import { render, staticRenderFns } from "./ManagerHoldingTimeline.vue?vue&type=template&id=813b9d94&scoped=true"
import script from "./ManagerHoldingTimeline.vue?vue&type=script&lang=js"
export * from "./ManagerHoldingTimeline.vue?vue&type=script&lang=js"
import style0 from "./ManagerHoldingTimeline.vue?vue&type=style&index=0&id=813b9d94&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "813b9d94",
  null
  
)

export default component.exports